export const locale = {
    lang: 'ru',
    data: {
        'TOOLBAR_RIGHT': {
            'PROFILE': 'Профиль',
            'MAIL': 'Почта',
            'LOGOUT': 'Выход'
        }
    }
};



// WEBPACK FOOTER //
// ./src/@fuse/components/search-bar/i18n/ru.ts